import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../services/firebase"; 
import { ReactComponent as InventarioIcon } from '../../assets/icons/InventarioIcon.svg';
import { ReactComponent as SearchIcon } from '../../assets/icons/SearchIcon.svg';
import FechaDateInput from '../FechaDateInput';
import { Combobox, Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/react";
import {
Chart as ChartJS,
CategoryScale,
LinearScale,
PointElement,
LineElement,
Title,
Tooltip,
Legend,
TimeScale,
} from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-date-fns";
ChartJS.register(
CategoryScale,
LinearScale,
PointElement,
LineElement,
Title,
TimeScale,
Tooltip,
Legend
);
// Un color fijo por motivo: asi no cambia si se reordena la lista de
// motivos (antes se asignaba por indice y los motivos 5 a 8 compartian color).
const COLOR_MOTIVO = {
    defecto: "#ed1e79",
    desconocido: "#8d8d8d",
    evento: "#29abe2",
    merma: "#fbb03b",
    muestra: "#00a99d",
    regalo: "#f15a24",
    ruptura: "#662d91",
    uso: "#39b54a",
};

const EstadisticasInventario = () => {
const [stock, setStock] = useState([]);
const [inventario, setInventario] = useState([]);
const [compras, setCompras] = useState([]);
const [ventas, setVentas] = useState([]);
const [selectedArticulo, setSelectedArticulo] = useState("");
const [selectedArticuloObjeto, setSelectedArticuloObjeto] = useState(null);
const [chartData, setChartData] = useState({});
const [visibleDatasets, setVisibleDatasets] = useState({});
const abreviaturas = {
Unidad: "u",
Kilos: "kg",
Gramos: "gr",
Litro: "lts",
Centilitros: "cl",
Mililitros: "ml",
};
const categorias = [
"Activos", "Almacén", "Depósito", "Enología",
"Finca", "Insumos", "Utilitarios"
];
const [selectedCategoria, setSelectedCategoria] = useState("Activos");
const [query, setQuery] = useState("");
const stockFiltrado = selectedCategoria
? stock.filter((item) => item.categoria === selectedCategoria)
: stock;
const filteredStock = query === ""
? stockFiltrado
: stockFiltrado.filter(
(item) => item.nombre?.toLowerCase().includes(query.toLowerCase())
);
useEffect(() => {
if (stockFiltrado.length > 0) {
if (!selectedArticulo) {
setSelectedArticuloObjeto(null);
return;
}
const articuloActualValido =
stockFiltrado.some(item => item.nombre === selectedArticulo);
if (!articuloActualValido) {
const primerArticulo = stockFiltrado[0];
setSelectedArticulo(primerArticulo.nombre);
setSelectedArticuloObjeto(primerArticulo);
} else {
const articulo = stockFiltrado.find(item => item.nombre === selectedArticulo);
setSelectedArticuloObjeto(articulo);
}
} else {
setSelectedArticulo("");
setSelectedArticuloObjeto(null);
}
}, [selectedCategoria, stockFiltrado, selectedArticulo]);
const hoy = new Date();
const hace30dias = new Date();
hace30dias.setDate(hoy.getDate() - 30);
const [startDate, setStartDate] = useState(hace30dias.toISOString().split("T")[0]);
const [endDate, setEndDate] = useState(hoy.toISOString().split("T")[0]);

// Estado temporal mientras el usuario escribe
const [draftStartDate, setDraftStartDate] = useState(startDate);
const [draftEndDate, setDraftEndDate] = useState(endDate);
useEffect(() => {
const fetchStock = async () => {
const querySnapshot = await getDocs(collection(db, "stock"));
// Vinos demo (DEMO-SHOP-*/DEMO-CUPO-*) de fincalosastros, no son stock real.
setStock(
querySnapshot.docs
.filter((doc) => !doc.id.startsWith("DEMO-"))
.map((doc) => doc.data())
);
};
const fetchInventario = async () => {
const querySnapshot = await getDocs(collection(db, "inventario"));
setInventario(querySnapshot.docs.map((doc) => doc.data()));
};
const fetchCompras = async () => {
const querySnapshot = await getDocs(collection(db, "compras"));
setCompras(querySnapshot.docs.map((doc) => doc.data()));
};
const fetchVentas = async () => {
const querySnapshot = await getDocs(collection(db, "ventas"));
setVentas(querySnapshot.docs.map((doc) => doc.data()));
};
fetchStock();
fetchInventario();
fetchCompras();
fetchVentas();
}, []);
useEffect(() => {
if (!selectedArticulo) return;
const desde = new Date(startDate);
const hastaFiltro = new Date(endDate + "T23:59:59.999");
// Los 8 motivos del dropdown de InventarioForm. Antes faltaban evento,
// regalo y muestra, y el filtro de abajo los descartaba en silencio:
// las salidas de botellas por esos motivos no aparecian en el grafico.
const motivos = ["defecto", "desconocido", "evento", "merma", "muestra", "regalo", "ruptura", "uso"]
const datosPorMotivo = {};
motivos.forEach((m) => (datosPorMotivo[m] = {}));
const ingresosMap = {};
const ventasMap = {};
(inventario.flatMap((inv) => inv.cambios || [])).forEach((cambio) => {
const fecha = cambio?.fecha && cambio.fecha.toDate ? cambio.fecha.toDate() : new Date(cambio?.fecha || Date.now());
if (isNaN(fecha)) return;
if (fecha >= desde && fecha <= hastaFiltro) {
const key = fecha.toISOString().split("T")[0];
if (motivos.includes(cambio.motivo)) {
if (cambio.nombre === selectedArticulo || cambio.id === selectedArticulo) {
datosPorMotivo[cambio.motivo][key] =
(datosPorMotivo[cambio.motivo][key] || 0) + Number(cambio.diferencia ?? 0);
}
}
}
});
(compras || []).forEach((compra) => {
const fechaCompra = compra?.fechaCompra && compra.fechaCompra.toDate ? compra.fechaCompra.toDate() : new Date(compra?.fechaCompra || Date.now());
if (isNaN(fechaCompra)) return;
if (fechaCompra >= desde && fechaCompra <= hastaFiltro) {
const key = fechaCompra.toISOString().split("T")[0];
(compra.articulos || []).forEach((art) => {
if (art.nombre === selectedArticulo || art.idProducto === selectedArticulo || art.id === selectedArticulo) {
ingresosMap[key] = (ingresosMap[key] || 0) + Number(art.cantidadUnidades ?? art.cantidad ?? 0);
}
});
}
});
if (selectedCategoria === "Vinos y Frutas") {
(ventas || []).forEach((venta) => {
const fechaVenta = venta?.fechaVenta?.toDate
? venta.fechaVenta.toDate()
: new Date(venta?.fechaVenta || Date.now());
if (isNaN(fechaVenta)) return;
if (fechaVenta >= desde && fechaVenta <= hastaFiltro) {
const key = fechaVenta.toISOString().split("T")[0];
(venta.productosVendidos || []).forEach((prod) => {
const nombre = prod.nombreProducto ?? prod.nombre ?? "";
const id = prod.idProducto ?? prod.id ?? "";
const cantidad = Number(prod.cantidad ?? prod.cantidadUnidades ?? 0);
if (nombre === selectedArticulo || id === selectedArticulo) {
ventasMap[key] =
(ventasMap[key] || 0) + (isNaN(cantidad) ? 0 : cantidad);
}
});
}
});
}
const fechasRango = [];
const temp = new Date(desde);
const tempHasta = new Date(hastaFiltro);
while (temp.getTime() <= tempHasta.getTime()) {
fechasRango.push(temp.toISOString().split("T")[0]);
temp.setDate(temp.getDate() + 1);
}
const getPointRadius = (context) => {
const value = context.raw;
const data = context.dataset.data;
const index = context.dataIndex;
if (value !== 0) {
return 2;
}
const prevValue = index > 0 ? data[index - 1] : null;
const nextValue = index < data.length - 1 ? data[index + 1] : null;
if (
(prevValue !== null && prevValue !== 0) ||
(nextValue !== null && nextValue !== 0)
) {
return 2;
}
return 0; 
};
const datasets = [];
if (selectedCategoria !== "Vinos y Frutas") {
datasets.push({
label: "Ingresos".charAt(0).toUpperCase() + "Ingresos".slice(1),
data: fechasRango.map((f) => ingresosMap[f] || 0),
borderColor: "#e65c5c",
backgroundColor: "#e65c5c",
tension: 0.01,
pointRadius: getPointRadius, borderWidth: 3,
clip: false, 
});
}
if (selectedCategoria === "Vinos y Frutas") {
datasets.push({
label: "Egresos".charAt(0).toUpperCase() + "Egresos".slice(1),
data: fechasRango.map((f) => ventasMap[f] || 0),
borderColor: "#0071bc",
backgroundColor: "#0071bc",
tension: 0.01,
pointRadius: getPointRadius, borderWidth: 3,
});
}
datasets.push(
...motivos.map((motivo) => ({
label: motivo.charAt(0).toUpperCase() + motivo.slice(1),
data: fechasRango.map((f) => datosPorMotivo[motivo][f] || 0),
borderColor: COLOR_MOTIVO[motivo] || "#8d8d8d",
backgroundColor: COLOR_MOTIVO[motivo] || "#8d8d8d",
tension: 0.01,
pointRadius: getPointRadius, borderWidth: 3,
}))
);
setChartData({ labels: fechasRango, datasets });
if (Object.keys(visibleDatasets).length === 0) {
const vis = {};
datasets.forEach((ds) => {
if (ds.label === "Ingresos" || ds.label === "Egresos") {
vis[ds.label] = true;
} else {
vis[ds.label] = false;
}
});
setVisibleDatasets(vis);
}
console.log("ventas.length", (ventas || []).length);
console.log("ventasMap (ejemplo)", ventasMap);
console.log("fechasRango", fechasRango);
}, [selectedArticulo, inventario, compras, ventas, startDate, endDate, selectedCategoria]);
const filteredDatasets = chartData.datasets
? chartData.datasets.filter((ds) => visibleDatasets[ds.label])
: [];
const unidad = selectedArticuloObjeto?.tipoUnidad || "Unidad";
const abreviatura = abreviaturas[unidad] || "u";

return (
<div
style={{ padding: '0 16px', position: 'relative', overflow: 'auto' }}
className="Trazabilidad"
>
<header
className="trazabilidad-header"
style={{
position: 'sticky',
top: '0',
backgroundColor: 'white',
zIndex: 10,
}}
>
<div
className="header-content"
style={{
display: 'flex',
justifyContent: 'space-between',
alignItems: 'center',
padding: '10px 0',
}}
>
<h1>Estadísticas</h1>
</div>
</header>
<div className="container" style={{ margin: '0 10px' }}>
<div className="formtitle-container">
<div className="formicon-container">
<InventarioIcon
className="formicon"
style={{ height: '16px', margin: 'auto' }}
/>
</div>
<h1 className="formtitle">Inventario</h1>
</div>
<hr className="divider" style={{ marginBottom: '0' }} />
<div className="currency-selector-container" style={{ gap: '3px' }}>
<span style={{ marginRight: '5px', fontFamily: 'Effra', fontSize: '12px'
}}>Seleccionar un grupo:</span>
{categorias.map((cat) => (
<button
key={cat}
onClick={() => setSelectedCategoria(cat)}
style={{ minWidth: 'fit-content', padding: '.5px 7px 1px', textTransform: 'uppercase', fontSize: '10px' }}
className={`currency-button ${selectedCategoria === cat ? 'active' : ''}`}
>
{cat}
</button>
))}
</div>
<div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', gap: '15px', borderBottom: '1px solid #e0e3e7', paddingBottom: '15px' }}>
<div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', gap: '10px' }}>
<SearchIcon
className="formicon"
style={{ height: '16px', margin: 'auto', fill: '#2c2c2c' }}
/>
<div style={{ position: 'relative' }}>
{}
<Combobox
value={selectedArticuloObjeto}
onChange={(selected) => {
setSelectedArticuloObjeto(selected);
setSelectedArticulo(selected ? selected.nombre : "");
}}
>
{({ open }) => (
<div style={{ position: "relative" }}>
<Combobox.Button
as="div"
className={`custom-listbox-button ${open ? "open" : ""} ${
selectedArticulo ? "selected" : "placeholder"
}`}
style={{ paddingLeft: "0", paddingRight: "0", width: '250px', padding: '1px 0' }}
>
<Combobox.Input
className="custom-combobox-input"
onChange={(event) => {
const newValue = event.target.value;
setQuery(newValue);
if (newValue === "") {
setSelectedArticuloObjeto(null);
setSelectedArticulo("");
}
}}
displayValue={(articuloObjeto) => articuloObjeto ? articuloObjeto.nombre : ""}
placeholder="Selecciona o busca un artículo"
style={{
flexGrow: 1,
padding: 0,
marginLeft: "15px",
border: "none",
outline: "none",
cursor:'pointer',
backgroundColor: "transparent",
}}
/>
<span className="custom-arrow-container" style={{ marginRight: "5px" }}>
<span className="custom-arrow"></span>
</span>
</Combobox.Button>
<Combobox.Options className="custom-listbox-options">
{filteredStock.length === 0 && query !== "" ? (
<div className="custom-listbox-option">No se encontraron artículos.</div>
) : (
filteredStock.map((item) => (
<Combobox.Option
key={item.nombre}
value={item}
className={({ active }) =>
`custom-listbox-option ${active ? "active" : ""}`
}
>
{item.nombre}
</Combobox.Option>
))
)}
</Combobox.Options>
</div>
)}
</Combobox>
</div>
</div>
<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '15px' }}>
<label style={{ fontSize: '12px', fontFamily: 'Effra', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
Desde:{" "}
<div className="input-group" style={{ width: 'fit-content', padding: '0' }}>
<FechaDateInput
  className="input"
  style={{ maxWidth: '77px', padding: '1px 10px' }}
    value={draftStartDate}
    onChange={(iso) => { setDraftStartDate(iso); setStartDate(iso); }}
/>
</div>
</label>
<label style={{ fontSize: '12px', fontFamily: 'Effra', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
  Hasta:
  <div className="input-group" style={{ width: 'fit-content', padding: '0' }}>
  <FechaDateInput
      className="input"
  style={{ maxWidth: '77px', padding: '1px 10px' }}
    value={draftEndDate}
    onChange={(iso) => { setDraftEndDate(iso); setEndDate(iso); }}
  /></div>
</label>

</div>
</div>
{selectedArticulo && chartData.datasets && (
<>
<div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
{chartData.datasets.map((ds) => {
const isActive = visibleDatasets[ds.label];
return (
<div
key={ds.label}
onClick={() =>
setVisibleDatasets((prev) => ({ ...prev, [ds.label]: !prev[ds.label] }))
}
style={{
display: "flex",
alignItems: "center",
cursor: "pointer",
userSelect: "none",
gap: "0.5rem",
}}
>
<div
style={{
width: "15px",
height: "15px",
borderRadius: "50%",
border: "2px solid #aaa",
display: "flex",
alignItems: "center",
justifyContent: "center",
}}
>
{isActive && (
<div
style={{
width: "50%",
height: "50%",
display: "flex",
borderRadius: "50%",
backgroundColor: ds.borderColor,
alignItems: "center",
justifyContent: "center",
}}
></div>
)}
</div>
<span style={{ fontFamily: 'Effra', fontSize: '13px' }}>{ds.label}</span>
</div>
);
})}
</div>
<div style={{ marginTop: "1rem", display: "flex", alignItems: "center", gap: "1rem" }}>
<span style={{ margin: 0, fontFamily: 'Effra', fontSize: '13px' }}>Totales del período:</span>
<div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
{filteredDatasets.map((ds, idx) => {
const total = ds.data.reduce((acc, val) => acc + val, 0);
return (
<React.Fragment key={ds.label}>
<span style={{ color: ds.borderColor, fontFamily: 'Effra', fontSize: '13px' }}>
{total} {abreviatura} {}
</span>
{idx < filteredDatasets.length - 1 && (
<span style={{ color: "#aaa", backgroundColor: "#aaa", height:'15px',width:'1px' }}></span>
)}
</React.Fragment>
);
})}
</div>
</div>
<div style={{ width: '75%', height: '350px', paddingTop: "25px", margin: ' 0 auto 0 120px', overflow:'visible' }}>
<Line
data={{ ...chartData, datasets: filteredDatasets }}
options={{
responsive: true,
maintainAspectRatio: false,
scales: {
x: {
type: "time",
time: {
unit: "day",
tooltipFormat: "dd/MM/yyyy",
displayFormats: { day: "dd/MM" },
},
ticks: { color: "#000000" },
grid: {
drawTicks: true,
tickColor: "#ffffff",
drawOnChartArea: false,
drawBorder: true,
},
},
y: {
min: 0,
ticks: {
color: "#000000",
callback: function(value, index, ticks) {
return value + ' ' + abreviatura;
},
},
grid: {
drawTicks: true,
tickColor: "#ffffff",
drawOnChartArea: false,
drawBorder: true,
},
},
},
plugins: {
legend: { display: false },
title: { display: false },
tooltip: {
backgroundColor: "white",
borderColor: (tooltipContext) => {
const datasetIndex = tooltipContext.tooltip.dataPoints[0].datasetIndex;
return tooltipContext.chart.data.datasets[datasetIndex].borderColor || '#000';
},
borderWidth: 2,
cornerRadius: 15,
displayColors: false,
titleColor: "black",
bodyColor: "black",
padding: { top: 8, bottom: 8, left: 15, right: 15 },
callbacks: {
title: () => null,
label: (context) => {
return `${context.formattedValue} ${abreviatura}`;
},
labelTextColor: (context) => context.dataset.borderColor,
},
},
},
}}
/>
</div>
</>
)}
</div>
</div>
);
};
export default EstadisticasInventario;
